<template>
  <div class="row">	
   <v-img  :src="titleIcon" :lazy-src="titleIcon"></v-img>
  </div> 
</template>

<script>
import axios from 'axios';
export default {
  data: function () {
    return {
      titleIcon: '',
    };
  },
  mounted() {
  	let parameters = this.$route.query
    this.viewArticle(parameters.title, parameters.type);
  },
  methods: {
    viewArticle(title, type) {
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formCatData = new FormData();
      formCatData.append('title', title);
      formCatData.append('type',  type);
      axios
        .post(
          process.env.VUE_APP_ROOT_API + 'view-article',
          formCatData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin': '*',
            },
  
          }
        )
        .then((response) => {
            this.titleIcon = response.data.data.image_with_logo
      });
    },
  },
};
</script>
